/* @flow */

export default class BuyerInvestmentSummaryPerformance {
  investmentReturn: number;
  irr: number;
  nbrOfInvoices: number;
  avgInvestmentDays: number;
}
